import {unitsModule} from "../../unitsModule";
import userManagementServer from "../../../userManagementServer";
import {LoadingService} from "../../../../bower_components/front-end-web-commons";
import {IHttpService} from "angular";


class TabGeneral {

    rootPresentationTreeNode: any = {}
    filterServiceUrl = "permission-group"


    constructor(private loadingService: LoadingService,
                private $http: IHttpService) {
        this.getPermissionGroupsPresentationTree();
    }

    getRootPresentationTreeNode() {
        return this.rootPresentationTreeNode;
    }

    getPermissionGroupsPresentationTree() {
        return this.loadingService(
            this.$http.get(userManagementServer.getServiceUrl("permission-group-company") + "presentation-tree-unity")
                .then((response: any) => {
                    this.rootPresentationTreeNode = response.data
                }));
    }


}

export const directive = unitsModule.directive("tabGeneral", [function () {
    return {
        restrict: "E",
        templateUrl: require("link!./tabGeneral.html"),
        scope: {
            onRegisterApi: "="
        },
        controllerAs: "ctrl",
        controller: TabGeneral,
    }
}])